class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.swiperEl = this;
        this.autoplaySpeed = +this.dataset.autoplaySpeed;
        this.paginationEl = this.querySelector('.product-tabs-pagination');
        this.slidePrev = this.querySelector('.product-tabs-prev');
        this.slideNext = this.querySelector('.product-tabs-next');
    }

    initSwiper() {
        if (typeof Swiper !== 'undefined') {
            this.swiper = new Swiper(this.swiperEl, {
                slidesPerView: "auto",
                spaceBetween: 20,
                freeMode: true,
                autoHeight: false,
                navigation: {
                  prevEl: this.slidePrev,
                  nextEl: this.slideNext
                },
            });
        }
    }

    connectedCallback() {
        this.initSwiper();
    }
}

if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
}